@defer (hydrate on immediate) {
	<div class="flex flex-col gap-12 md:gap-24 pt-32">
		<div class="flex flex-col xl:flex-row justify-around items-center gap-x-4 gap-y-16">
			<peps-title
				[title]="'common.matches.lowercase' | translate">
			</peps-title>
			<div class="flex flex-col gap-4 p-4 border border-peps-dark-600 bg-peps-dark-700 mx-4">
				<span class="uppercase">{{ 'page.matchs.follow-team-peps' | translate }}</span>
				<div class="flex flex-row gap-4 justify-center flex-wrap">
					<a
						class="uppercase group cursor-pointer text-peps-purple transition-colors duration-300 pb-4 border-b-2 hover:text-peps-purple-hover hover:border-b-peps-purple-hover flex flex-row items-center gap-2 w-fit text-xl"
						href="https://www.twitch.tv/fefegg"
					>
						<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M15.9293 8.35757L13.3578 10.929H10.7864L8.53641 13.179V10.929H5.64355V1.28613H15.9293V8.35757Z" fill="white"/>
							<path d="M5.00042 0L1.78613 3.21429V14.7857H5.64328V18L8.85756 14.7857H11.429L17.2147 9V0H5.00042ZM15.929 8.35714L13.3576 10.9286H10.7861L8.53613 13.1786V10.9286H5.64328V1.28571H15.929V8.35714Z" fill="#9146FF"/>
							<path d="M14.0006 3.53613H12.7148V7.39328H14.0006V3.53613Z" fill="#9146FF"/>
							<path d="M10.4644 3.53613H9.17871V7.39328H10.4644V3.53613Z" fill="#9146FF"/>
						</svg>
						féfé
					</a>
					<a
						class="uppercase group cursor-pointer text-peps-purple transition-colors duration-300 pb-4 border-b-2 hover:text-peps-purple-hover hover:border-b-peps-purple-hover flex flex-row items-center gap-2 w-fit text-xl"
						href="https://www.twitch.tv/teampepsmax"
					>
						<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M15.9293 8.35757L13.3578 10.929H10.7864L8.53641 13.179V10.929H5.64355V1.28613H15.9293V8.35757Z" fill="white"/>
							<path d="M5.00042 0L1.78613 3.21429V14.7857H5.64328V18L8.85756 14.7857H11.429L17.2147 9V0H5.00042ZM15.929 8.35714L13.3576 10.9286H10.7861L8.53613 13.1786V10.9286H5.64328V1.28571H15.929V8.35714Z" fill="#9146FF"/>
							<path d="M14.0006 3.53613H12.7148V7.39328H14.0006V3.53613Z" fill="#9146FF"/>
							<path d="M10.4644 3.53613H9.17871V7.39328H10.4644V3.53613Z" fill="#9146FF"/>
						</svg>
						teampepsmax
					</a>
					<a
						class="uppercase group cursor-pointer text-peps-red transition-colors duration-300 pb-4 border-b-2 hover:text-peps-red-hover hover:border-b-peps-red-hover flex flex-row items-center gap-2 w-fit text-xl"
						href="https://www.youtube.com/fefegg"
					>
						<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_1194_2374)">
								<path d="M18.1412 4.63918C18.0395 4.25624 17.8389 3.90674 17.5596 3.62567C17.2803 3.3446 16.9321 3.14181 16.5499 3.03759C15.1426 2.65918 9.51758 2.65918 9.51758 2.65918C9.51758 2.65918 3.89258 2.65918 2.48531 3.03759C2.10303 3.14181 1.75482 3.3446 1.47554 3.62567C1.19627 3.90674 0.995707 4.25624 0.893942 4.63918C0.517578 6.05259 0.517578 9.00009 0.517578 9.00009C0.517578 9.00009 0.517578 11.9476 0.893942 13.361C0.995707 13.7439 1.19627 14.0934 1.47554 14.3745C1.75482 14.6556 2.10303 14.8584 2.48531 14.9626C3.89258 15.341 9.51758 15.341 9.51758 15.341C9.51758 15.341 15.1426 15.341 16.5499 14.9626C16.9321 14.8584 17.2803 14.6556 17.5596 14.3745C17.8389 14.0934 18.0395 13.7439 18.1412 13.361C18.5176 11.9476 18.5176 9.00009 18.5176 9.00009C18.5176 9.00009 18.5176 6.05259 18.1412 4.63918Z" fill="#FF0302"/>
								<path d="M7.67676 11.6762V6.32324L12.3813 8.99972L7.67676 11.6762Z" fill="#FEFEFE"/>
							</g>
							<defs>
								<clipPath id="clip0_1194_2374">
									<rect width="18" height="18" fill="white" transform="translate(0.5)"/>
								</clipPath>
							</defs>
						</svg>
						féfé
					</a>
					<a
						class="uppercase group cursor-pointer text-peps-red transition-colors duration-300 pb-4 border-b-2 hover:text-peps-red-hover hover:border-b-peps-red-hover flex flex-row items-center gap-2 w-fit text-xl"
						href="https://www.youtube.com/@TeamPepsMAX"
					>
						<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_1194_2374)">
								<path d="M18.1412 4.63918C18.0395 4.25624 17.8389 3.90674 17.5596 3.62567C17.2803 3.3446 16.9321 3.14181 16.5499 3.03759C15.1426 2.65918 9.51758 2.65918 9.51758 2.65918C9.51758 2.65918 3.89258 2.65918 2.48531 3.03759C2.10303 3.14181 1.75482 3.3446 1.47554 3.62567C1.19627 3.90674 0.995707 4.25624 0.893942 4.63918C0.517578 6.05259 0.517578 9.00009 0.517578 9.00009C0.517578 9.00009 0.517578 11.9476 0.893942 13.361C0.995707 13.7439 1.19627 14.0934 1.47554 14.3745C1.75482 14.6556 2.10303 14.8584 2.48531 14.9626C3.89258 15.341 9.51758 15.341 9.51758 15.341C9.51758 15.341 15.1426 15.341 16.5499 14.9626C16.9321 14.8584 17.2803 14.6556 17.5596 14.3745C17.8389 14.0934 18.0395 13.7439 18.1412 13.361C18.5176 11.9476 18.5176 9.00009 18.5176 9.00009C18.5176 9.00009 18.5176 6.05259 18.1412 4.63918Z" fill="#FF0302"/>
								<path d="M7.67676 11.6762V6.32324L12.3813 8.99972L7.67676 11.6762Z" fill="#FEFEFE"/>
							</g>
							<defs>
								<clipPath id="clip0_1194_2374">
									<rect width="18" height="18" fill="white" transform="translate(0.5)"/>
								</clipPath>
							</defs>
						</svg>
						team peps
					</a>
				</div>
			</div>
		</div>
		<div class="flex flex-col gap-10">
			<div class="flex flex-row mx-auto sm:hidden bg-peps-dark-700">
				<button
					class="uppercase cursor-pointer p-4 relative overflow-hidden text-white transition-colors duration-300"
					(click)="toggleTypeOfMatch('upcoming')"
				>
					<span
						[ngClass]="{'text-peps-gold': selectedTypeOfMatch === 'upcoming'}"
						class="relative z-10 transition-colors duration-300"
					>{{ 'page.matchs.coming-soon' | translate }}</span>
					<div
						class="absolute inset-0 bg-peps-dark-600 transition-transform duration-300 origin-right scale-x-0"
						[ngClass]="{ 'scale-x-100': selectedTypeOfMatch === 'upcoming' }"
					></div>
				</button>

				<button
					class="uppercase cursor-pointer p-4 relative overflow-hidden text-white transition-colors duration-300"
					(click)="toggleTypeOfMatch('result')"
				>
					<span
						class="relative z-10 transition-colors duration-300"
						[ngClass]="{'text-peps-gold': selectedTypeOfMatch === 'result'}"
					>{{ 'page.matchs.result' | translate }}</span>
					<div
						class="absolute inset-0 bg-peps-dark-600 transition-transform duration-300 origin-left scale-x-0"
						[ngClass]="{ 'scale-x-100': selectedTypeOfMatch === 'result' }"
					></div>
				</button>
			</div>
			<div class="flex flex-col sm:flex-row justify-around gap-4 items-center w-11/12 md:w-9/12 mx-auto border-b border-b-peps-dark-600 bg-peps-dark-700">

				<peps-event-filter
					(filterChange)="updateEventTypeFilter($event)"
					[selectedEvents]="selectedEvents"
				></peps-event-filter>

				<div class="sm:flex flex-row hidden">
					<button
						class="uppercase cursor-pointer p-4 relative overflow-hidden text-white transition-colors duration-300"
						(click)="toggleTypeOfMatch('upcoming')"
					>
						<span
							[ngClass]="{'text-peps-gold': selectedTypeOfMatch === 'upcoming'}"
							class="relative z-10 transition-colors duration-300"
						>{{ 'page.matchs.coming-soon' | translate }}</span>
						<div
							class="absolute inset-0 bg-peps-dark-600 transition-transform duration-300 origin-right scale-x-0"
							[ngClass]="{ 'scale-x-100': selectedTypeOfMatch === 'upcoming' }"
						></div>
					</button>

					<button
						class="uppercase cursor-pointer p-4 relative overflow-hidden text-white transition-colors duration-300"
						(click)="toggleTypeOfMatch('result')"
					>
						<span
							class="relative z-10 transition-colors duration-300"
							[ngClass]="{'text-peps-gold': selectedTypeOfMatch === 'result'}"
						>{{ 'page.matchs.result' | translate }}</span>
						<div
							class="absolute inset-0 bg-peps-dark-600 transition-transform duration-300 origin-left scale-x-0"
							[ngClass]="{ 'scale-x-100': selectedTypeOfMatch === 'result' }"
						></div>
					</button>
				</div>

				<div class="flex flex-row gap-2">
					<span class="font-notosans text-base">{{ 'page.matchs.view-score' | translate }}</span>
					<peps-toggle
						[checked]="isShowingScore"
						(checkedChange)="toggleScoreVisibility($event)"
					></peps-toggle>
				</div>
			</div>
			<div class="flex flex-col gap-7">

				@if(filteredMatches.length > 0) {
					<peps-matchs-container
						[matches]="filteredMatches"
						[isShowingScore]="isShowingScore"
					></peps-matchs-container>
				} @else {
					@if(selectedTypeOfMatch === 'upcoming') {
						<peps-no-upcoming-match></peps-no-upcoming-match>
					} @else {
						<div class="flex flex-col items-center justify-center gap-10">
							<img src="/assets/images/no-match.avif" alt="Pas de match">
							<span class="uppercase text-4xl md:text-6xl w-8/12 text-center">{{ 'component.no-result-match.text' | translate }}</span>
						</div>
					}
				}

				@if(totalPages > 1 && filteredMatches.length > 0) {
					<peps-page-selector
						[page]="page"
						[totalPages]="totalPages"
						(pageChange)="onPageChange($event)"
					></peps-page-selector>
				}
			</div>
		</div>
		<peps-last-videos></peps-last-videos>

	</div>
}
